import { render } from "./AFooter.vue?vue&type=template&id=41aa843d"
import script from "./AFooter.vue?vue&type=script&lang=js"
export * from "./AFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__